export default __webpack_public_path__ + "static/media/midasi_entry_ja_sp.038418c8.png";